import { render, staticRenderFns } from "./openAlipayWithholdProtocolDialog.vue?vue&type=template&id=7d6922c6&scoped=true"
import script from "./openAlipayWithholdProtocolDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./openAlipayWithholdProtocolDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./openAlipayWithholdProtocolDialog.vue?vue&type=style&index=0&id=7d6922c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6922c6",
  null
  
)

export default component.exports